<app-page-layout [center]="true">
  @if (!authResolved()) {
    <h1 class="hero-title">Welcome to the MPC Advanced Queries Interface (MAQI)</h1>
    <p class="auth-loading">Restoring your session...</p>
  } @else if (!isAuthenticated()) {
    <h1 class="hero-title">Welcome to the MPC Advanced Queries Interface (MAQI)</h1>
    <app-login [showTitle]="false" />
  } @else {
    <h1 class="hero-title">
      Welcome <span class="username">{{ displayName() }}</span>! You are logged in.
    </h1>
    <app-queue-stats
      [showDetails]="false"
      [compact]="true"
      title="API Usage & Queue Health"
    />
    <app-query-form />
  }
</app-page-layout>
